import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type PropsWithChildren } from 'react';

import ConfirmServiceHost from '../lib/confirm-service';
import { ThemeProvider } from '../lib/theme';
import { ToastProvider } from '../lib/toast';

export const AppProviders = ({ children }: PropsWithChildren) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            retry: 1,
            refetchOnWindowFocus: false,
          },
          mutations: { retry: 0 },
        },
      }),
  );

  return (
    <ThemeProvider>
      <ToastProvider>
        <QueryClientProvider client={queryClient}>
          {children}
          <ConfirmServiceHost />
        </QueryClientProvider>
      </ToastProvider>
    </ThemeProvider>
  );
};
